let environment = 'localhost'

const CONFIG = {
  'xsd.milestonesys.wdev': {
    MILESTONE_URL: 'https://www.milestonesys.wdev',
    API_URL: 'https://xsdapi.milestonesys.wdev/api',
    API_URL_FELL: 'https://xsdfell.milestonesys.wdev',
    CLIENT_URL: 'https://xsd.milestonesys.wdev',
    IDENTITY_MANAGER_CONFIG: {
      client_id: 'a3e6d691-fdae-4333-9388-431a6d9a2e90',
      authority: 'https://id.milestonelogin.xyz/6978af3d-26be-4e79-903b-403635a4db5c',
      redirect_uri: 'https://xsd.milestonesys.wdev/authentication-callback',
      post_logout_redirect_uri: 'https://xsd.milestonesys.wdev/',
      scopes: [
        'openid',
        'profile',
        'email',
        'offline_access',
        'api://7ab2e9ab-ddc7-43da-af0f-7bb4d83aae44/access_as_user'
      ],
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false
    }
  },
  'xsd.milestonesys.wtst': {
    MILESTONE_URL: 'https://www.milestonesys.wtst',
    API_URL: 'https://xsdapi.milestonesys.wtst/api',
    API_URL_FELL: 'https://xsdfell.milestonesys.wtst',
    CLIENT_URL: 'https://xsd.milestonesys.wtst',    
    IDENTITY_MANAGER_CONFIG: {
      client_id: 'a3e6d691-fdae-4333-9388-431a6d9a2e90',
      authority: 'https://id.milestonelogin.xyz/6978af3d-26be-4e79-903b-403635a4db5c',
      redirect_uri: 'https://xsd.milestonesys.wtst/authentication-callback',
      post_logout_redirect_uri: 'https://xsd.milestonesys.wtst/',
      scopes: [
        'openid', 
        'profile', 
        'email', 
        'offline_access', 
        'api://7ab2e9ab-ddc7-43da-af0f-7bb4d83aae44/access_as_user'
      ],
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false
    }
  },
  'xsd.milestonesys.xyz': {
    MILESTONE_URL: 'https://www.milestonesys.xyz',
    API_URL: 'https://xsdapi.milestonesys.xyz/api',
    API_URL_FELL: 'https://xsdfell.milestonesys.xyz',
    CLIENT_URL: 'https://xsd.milestonesys.xyz',    
    IDENTITY_MANAGER_CONFIG: {
      client_id: 'a3e6d691-fdae-4333-9388-431a6d9a2e90',
      authority: 'https://id.milestonelogin.xyz/6978af3d-26be-4e79-903b-403635a4db5c',
      redirect_uri: 'https://xsd.milestonesys.xyz/authentication-callback',
      post_logout_redirect_uri: 'https://xsd.milestonesys.xyz/',
      scopes: [
        'openid',
        'profile',
        'email',
        'offline_access',
        'api://7ab2e9ab-ddc7-43da-af0f-7bb4d83aae44/access_as_user'
      ],
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false
    }

  },
  'xsd.milestonesys.com': {
    MILESTONE_URL: 'https://www.milestonesys.com',
    API_URL: 'https://xsdapi.milestonesys.com/api',
    API_URL_FELL: 'https://xsdfell.milestonesys.com',
    CLIENT_URL: 'https://xsd.milestonesys.com',
    IDENTITY_MANAGER_CONFIG: {
      client_id: '2820f658-9d55-4567-9326-a2564a95ef2f',
      authority: 'https://id.milestonelogin.com/4321ea88-b4d3-4729-a8db-e18baa8c6f30',
      redirect_uri: 'https://xsd.milestonesys.com/authentication-callback',
      post_logout_redirect_uri: 'https://xsd.milestonesys.com/',
      scopes: [
        'openid', 
        'profile', 
        'email', 
        'offline_access', 
        'api://fdaaeebe-406c-4b28-aaa9-4f9ce81749ad/access_as_user'
      ],
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false
    }
  },
  localhost: {
    MILESTONE_URL: 'https://www.milestonesys.xyz',
    API_URL: 'https://localhost:44383/api',
    API_URL_FELL: 'https://localhost:49604',
    CLIENT_URL: 'http://localhost:3000',
    IDENTITY_MANAGER_CONFIG: {
      client_id: 'a3e6d691-fdae-4333-9388-431a6d9a2e90',
      authority: 'https://id.milestonelogin.xyz/6978af3d-26be-4e79-903b-403635a4db5c',
      redirect_uri: 'http://localhost:3000/authentication-callback',
      post_logout_redirect_uri: 'http://localhost:3000/',
      scopes: [
        'openid',
        'profile',
        'email',
        'offline_access',        
        'api://7ab2e9ab-ddc7-43da-af0f-7bb4d83aae44/access_as_user'
      ],
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false
    }
  }
}

export const loadConfig = () => {
  environment = window.location.host.split(':')[0]
}

export const API_URL = () => CONFIG[environment].API_URL
export const API_URL_FELL = () => CONFIG[environment].API_URL_FELL
export const CLIENT_URL = () => CONFIG[environment].CLIENT_URL
export const MILESTONE_URL = () => CONFIG[environment].MILESTONE_URL
export const ENV = () => environment

export const IDENTITY_MANAGER_CONFIG = () => CONFIG[environment].IDENTITY_MANAGER_CONFIG
